import { Component } from '@angular/core';

@Component({
    standalone: false,
    selector: 'mibi-reset-view',
    templateUrl: './reset-view.component.html'
})
export class ResetViewComponent {
}
